import React from "react";
import { FileText } from "lucide-react";
import { Card, Toggle, Textarea } from "./FormComponents";

export const Step16 = ({ data, updateData, isLight, showValidation }) => {
  const handleNestedChange = (parent, field, value) => {
    updateData("policies", {
      ...data,
      [parent]: {
        ...data[parent],
        [field]: value
      }
    });
  };

  return (
    <div className="flex flex-col gap-8">
      <Card title="Booking Terms & Policies" icon={FileText} subtitle="Important booking terms handled through the platform or applicable regulations." isLight={isLight}>
        <div className="flex flex-col gap-8">
          <div className="flex flex-col gap-6">
            <Toggle 
              label="Cancellation and modification policy is defined by the booking platform and reservation terms." 
              value={data.bookingTerms.definedByPlatform} isLight={isLight}
              onChange={(val) => {
                const updates = { definedByPlatform: val };
                if (val) updates.customCancellationPolicy = "";
                updateData("policies", { ...data, bookingTerms: { ...data.bookingTerms, ...updates } });
              }}
            />

            {!data.bookingTerms.definedByPlatform && (
              <div className="pl-4 border-l-2 border-blue-500/20">
                <Textarea 
                  label="Custom Cancellation & Modification Policy" required 
                  placeholder="Enter your custom policy here..."
                  value={data.bookingTerms.customCancellationPolicy || ""} isLight={isLight}
                  showValidation={showValidation}
                  onChange={(e) => handleNestedChange("bookingTerms", "customCancellationPolicy", e.target.value)}
                />
              </div>
            )}
          </div>

          <div className="flex flex-col gap-6">
            <Toggle 
              label="Refunds are handled according to the terms of the booking platform used for the reservation." 
              value={data.bookingTerms.refundsByTerms} isLight={isLight}
              onChange={(val) => {
                const updates = { refundsByTerms: val };
                if (val) updates.customRefundPolicy = "";
                updateData("policies", { ...data, bookingTerms: { ...data.bookingTerms, ...updates } });
              }}
            />

            {!data.bookingTerms.refundsByTerms && (
              <div className="pl-4 border-l-2 border-blue-500/20">
                <Textarea 
                  label="Custom Refund Policy" required 
                  placeholder="Enter your custom refund policy here..."
                  value={data.bookingTerms.customRefundPolicy || ""} isLight={isLight}
                  showValidation={showValidation}
                  onChange={(e) => handleNestedChange("bookingTerms", "customRefundPolicy", e.target.value)}
                />
              </div>
            )}
          </div>

          <div className="flex flex-col gap-6">
            <Toggle 
              label="Any charges related to damage, loss, or excessive cleaning are handled in accordance with the booking platform’s policies and procedures." 
              value={data.bookingTerms.damageByPlatform} isLight={isLight}
              onChange={(val) => {
                const updates = { damageByPlatform: val };
                if (val) updates.customDamagePolicy = "";
                updateData("policies", { ...data, bookingTerms: { ...data.bookingTerms, ...updates } });
              }}
            />

            {!data.bookingTerms.damageByPlatform && (
              <div className="pl-4 border-l-2 border-blue-500/20">
                <Textarea 
                  label="Custom Damage & Cleaning Policy" required 
                  placeholder="Enter your custom damage policy here..."
                  value={data.bookingTerms.customDamagePolicy || ""} isLight={isLight}
                  showValidation={showValidation}
                  onChange={(e) => handleNestedChange("bookingTerms", "customDamagePolicy", e.target.value)}
                />
              </div>
            )}
          </div>
          
          <Toggle 
            label="Guests are required to comply with any applicable local laws, regulations, identification procedures, registration requirements, and taxes related to their stay, where applicable." 
            value={data.bookingTerms.localCompliance} isLight={isLight}
            onChange={(val) => handleNestedChange("bookingTerms", "localCompliance", val)}
          />
        </div>
      </Card>
    </div>
  );
};
